module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"refreshTokenSuccess":"Refresh token success","refreshTokenError":"Refresh token error","cacheLoadingError":"Error loading the menu data"},"es":{"refreshTokenSuccess":"Éxito refrescando token","refreshTokenError":"Error refrescando token:","cacheLoadingError":"Error cargando los datos del menu"}}')
  delete Component.options._Ctor
}
